import {
  convertLabelMapToConfig,
  convertLabelUomMapToConfig,
  mergeConfig,
} from 'Components/Worksheets/Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.IsDispersantUsed`]: 'Dispersing Solution',

      [`${prefix}.Equipment.WashingSieve`]: '75 µm Sieve',
      [`${prefix}.Equipment.GuardSieve`]: 'Guard Sieve',

      // [`${prefix}.Masses.InitialDryMass`]: 'Initial Material Dry Mass',

      [`${prefix}.Masses.MeasuredWashedConstantDryMass.Preparation.MeasureWashedPortionWetMass`]:
        'Measure washed portion wet mass',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTray.DateTimePlacedInOvenLocal`]: 'Date and Time in Oven',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTray.DryMassReadings.DryingTime`]: 'Drying Time',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTray.ContainerLabel`]: 'Tare ID',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTray.ContainerMass`]: 'Washing Tare Mass',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTray.WetSoilMass`]: 'Portion Wet Washed Mass',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTray.DryMassReadings.DrySoilAndContainerMass`]:
        'Portion Washed Dry Mass',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTray.WetSoilAndContainerMass`]:
        'Tare and Portion Wet Washed Mass',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.Equipment.Balance`]: 'Washing Balance',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.Equipment.DryMassBalance`]: 'Dry Mass Balance',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.Equipment.Oven`]: 'Oven',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.Equipment.MicrowaveOven`]: 'Microwave Oven',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.Equipment.InfraredLight`]: 'Infrared Light',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.Equipment.Hotplate`]: 'Hotplate',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.Equipment.DryingEquipment`]: 'Drying By',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.Equipment.DryingTemperature`]: 'Oven Temperature',

      [`${prefix}.Masses.WashedDryMass`]: 'Portion Dry Washed Mass',

      [`${prefix}.Results.PercentPassingWashingSieve`]: 'Loss from Washing',
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Results.PercentPassingWashingSieve`]: '%',
    })
  );

export default getLabelConfig;
